import { useEffect, lazy, Suspense } from 'react'
import { Routes, Route, useLocation ,useNavigate} from "react-router-dom"
import './App.css';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { ErrorBoundary } from 'react-error-boundary';
import axios from 'axios'

// import './components/HomePage/NavBar'
// import NavBar from './components/HomePage/NavBar';
// import Home from './pages/Home';
// import Dartaksit from './pages/Dartaksit'
// import Daridjar from './pages/Daridjar';
// import Dari3mar from './pages/Dari3mar';
// import Popup from './components/Global/Popup';
import { Provider } from './Context/bank';
import { LangProvider } from './Context/lang';
import { CartProvider } from './Context/cart';



import ScrollToTop from './ScrollToTop';

import FallbackComponent from './components/Global/FallbackComponent';


const JumiaOrderLazy = lazy(() => import('./pages/JumiaOrder'));


const queryClient = new QueryClient()





function App() {

  const location = useLocation();
  const navigate = useNavigate();

  // console.log('pathname', location.pathname);


  // const getBank = localStorage.getItem('bank');
  // const getBank = 'bna';



  // console.log(location.pathname.split('/')[1]);

  // useEffect(() => {
  //   const dataLayer = window.dataLayer || [];
  //   function gtag() { dataLayer.push(arguments); }
  //   gtag('js', new Date());

  //   gtag('config', 'G-5DJPJ9DWE3');

  // }, [])

  const handleError = async (error, info) => {
    // Send the error to your backend
     // const url = "http://localhost:8089";
     const url = "https://diardzair.shop/api";
    try {
      await axios.post(`${url}/test/error_reporting`, {
        error: error?.toString(),
        stack: info?.componentStack,
        path : window.location.href
      });
    } catch (err) {
      console.error('Failed to log error to the backend', err);
    }

    // console.log( error);

    // Redirect to the homepage after logging the error
     return window.location = "/";
  };

  return (
    <ErrorBoundary FallbackComponent={FallbackComponent}  onError={handleError}>
    <div className="App">
      <QueryClientProvider client={queryClient}>

        <LangProvider>
          <CartProvider>
            <Provider>
              {/* {location.pathname.split('/')[1] !== "store" && location.pathname.split('/')[1] !== "boutique" && location.pathname !== "/aide" && location.pathname !== "/i3mal" && location.pathname !== "/moto" && location.pathname !== "/i3malhome" && location.pathname.split('/')[1] !== "i3malform" && location.pathname.split('/')[1] !== "validationi3mal" && location.pathname !== "/store" && location.pathname !== "/account" && location.pathname.split('/')[1] !== "simulation" && (location.pathname.split('/')[1] + "/" + location.pathname.split('/')[2]) !== "daridjar/inscription" && location.pathname.split('/')[1] !== "validation" && location.pathname !== "/simulationcart" && location.pathname !== "/profil" && location.pathname !== "/mescommandes" && location.pathname !== "/saidaty" && location.pathname.split('/')[1] !== "saidatyform" && location.pathname.split('/')[1] !== "validationsaidaty" && location.pathname.split('/')[1] !== "darsiyaha" && location.pathname.split('/')[1] !== "darhiref" ? <NavBar Section={location.pathname} /> : ''} */}

              {/* {getBank == null ? <Popup /> : ''} */}

              <ScrollToTop>
              
                <Routes>

                  {/* <Route path="/" element={<Layout />}>
                   
              



                  </Route> */}

                    {/* <Route path="*" element={<JumiaOrderLazy />} />
                    <Route index element={<JumiaOrderLazy />} /> */}
                    <Route path="/jumia/:id_order" element={<JumiaOrderLazy />} />








                </Routes>
              </ScrollToTop>
            </Provider>
          </CartProvider>
        </LangProvider>
      </QueryClientProvider>
    </div>
    </ErrorBoundary>
  );
}

export default App;
